import * as yup from 'yup';

import { parseCurrencyIntoFloat } from 'app/utils/strings';

import { validateDate, validateEmail, validateSalaryRange } from 'app/utils/validations';

export const employeeCompanyFormSchema = yup.object().shape({
  companyId: yup.string().required('Company is mandatory'),
});

export const employeeDetailsFormSchema = yup.object().shape({
  firstName: yup
    .string()
    .required('First name is mandatory')
    .min(2, 'First name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "First name should only contain letters, spaces, and symbols (.-')"
    ),
  lastName: yup
    .string()
    .required('Last name is mandatory')
    .min(2, 'Last name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "Last name should only contain letters, spaces, and symbols (.-')"
    ),
  email: yup
    .string()
    .required('Email is mandatory')
    .test('Invalid email', 'Enter a valid email', (value) => validateEmail(value)),
  additionalEmail: yup
    .string()
    .test('Invalid email', 'Enter a valid email', (value) => !value || validateEmail(value)),
});

export const employeePayCalendarFormSchema = yup.object().shape({
  payCalendarId: yup.string().required('Pay calendar is mandatory'),
  externalPayrollId: yup.string().required('External payroll ID is mandatory'),
  startDate: yup
    .string()
    .test('Invalid date', 'Enter a valid date', (value) => !value || validateDate(value)),
});

export const employeeSalaryFormSchema = yup.object().shape({
  annualGrossSalary: yup
    .number()
    .transform((_, originalValue) => {
      const parsedSalary = parseCurrencyIntoFloat(originalValue);
      return Number.isNaN(parsedSalary) ? undefined : parsedSalary;
    })
    .test(
      'Invalid salary range',
      'Salary must be between £4,000 and £500,000',
      (value) => value === undefined || validateSalaryRange(value)
    ),
  salaried: yup.boolean().required('Salaried status is mandatory'),
});
